import React, { useEffect, useState } from "react";
import ImagesModal from "../../../../../components/common/modals/imgaes-modal/ImagesModal";
import Button from "../../../../../components/common/button/Button";
import { publicImageProps } from "../../../../../services/config";
import { PiImageSquareFill, PiXFill } from "react-icons/pi";
import {
  successMessage,
  warningMessage,
} from "../../../../../utils/toastify-message/ToastifyMessage";

const { forwardRef, useRef, useImperativeHandle } = React;

const ProductImages = forwardRef(({ handleImages, oldImages }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [images, setImages] = useState([]);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {
      setImages([]);
    },
  }));

  const imagesModal = useRef();

  const selectedImages = (data) => {
    const isExist = images.filter((item) => {
      return item.name == data?.name;
    });
    if (isExist.length) {
      warningMessage("عکس از قبل وجود دارد");
    } else {
      successMessage("عکس با موفقیت اضافه شد.");
      setImages((prevState) => [...prevState, data]);
    }
  };

  const setMainImage = (image) => {
    const newImages = images.map((item) => {
      if (item.name == image.name) {
        item["isMain"] = true;
      } else {
        item["isMain"] = false;
      }
      return item;
    });
    console.log(newImages);
    setImages(newImages);
  };

  const delteImage = (image) => {
    const newImages = images.filter((item) => {
      return item.name !== image.name;
    });
    console.log(newImages);
    setImages(newImages);
  };

  const handleNewImage = () => {
    if (images.length > 0) {
      const newImages = images.filter((item) => {
        return item.isMain == true;
      });
      if (newImages.length > 0) {
        handleImages(images);
        setShowModal(false);
      } else {
        const imagesWithIsMain = images.map((item, index) => {
          if (index == 0) {
            item["isMain"] = true;
          }
          return item;
        });
        handleImages(imagesWithIsMain);
        setShowModal(false);
      }
    } else {
      handleImages([]);
      setShowModal(false);
    }
  };

  useEffect(() => {
    setImages(oldImages);
  }, [oldImages]);

  return (
    <>
      <div
        className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-20  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        hidden={!showModal}
        role="dialog"
        aria-label="تصاویر محصول"
        aria-modal="true"
        className={`admin-edit-drawer w-full min-h-full bg-white shadow-md z-30 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0 is-open"
        }`}
      >
        <div className="w-full flex flex-wrap gap-3 items-center justify-between py-4 border-b">
          <h4>عکس های محصول</h4>
          <div className="flex items-center gap-2">
            <Button
              type="button"
              onClick={() => imagesModal.current.showModal()}
              text={"افزودن عکس جدید"}
              color={"success"}
            />
            <Button
              onClick={handleNewImage}
              type="button"
              color="primary"
              text="بازگشت"
            />
          </div>
        </div>

        {images?.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
            {images.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`w-auto overflow-hidden cursor-pointer rounded-lg flex items-center justify-center relative ${
                    item.isMain == true && "border-2 border-green-400"
                  }`}
                >
                  <PiXFill
                    onClick={() => delteImage(item)}
                    size={30}
                    className="text-red-400 cursor-pointer absolute right-1 top-1 z-10 transition-all hover:text-red-600"
                  />

                  <img
                    onClick={() => setMainImage(item)}
                    className="h-auto max-w-full rounded-lg transition-all hover:scale-105"
                    {...publicImageProps(item.name)}
                    alt=""
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2 py-4 w-full mt-6 text-gray-700">
            شما هنوز عکسی انتخاب نکرده اید
            <PiImageSquareFill size={50} />
          </div>
        )}
      </div>

      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </>
  );
});

export default ProductImages;
